import api from '@/api'
import {
  SET_LOADING_SMS_TEMPLATE,
  SET_SMS_TEMPLATE_PARAMS,
  SET_TEMPLATE_SMS_LIST,
} from './mutation-types'

const state = {
  loadingSMSTemplate: false,
  templateSMSParams: {
    templateStatus: '',
    templateType: '',
  },
  templateSMSList: [],
}

const mutations = {
  [SET_TEMPLATE_SMS_LIST](state, payload) {
    state.templateSMSList = payload
  },
  [SET_LOADING_SMS_TEMPLATE](state, payload) {
    state.loadingSMSTemplate = payload
  },
  [SET_SMS_TEMPLATE_PARAMS](state, { key, value }) {
    state.templateSMSParams[key] = value
  },
}

const actions = {
  // 增加短信模板
  async queryTemplateList({ commit, state }) {
    const params = {}
    const { templateStatus, templateType } = state.templateSMSParams
    if (templateStatus !== '') {
      params.templateStatus = templateStatus
    }
    if (templateType !== '') {
      params.templateType = templateType
    }
    commit(SET_LOADING_SMS_TEMPLATE, true)
    try {
      const { data, code } = await api.dataGraphApi.queryTemplateList(params)
      commit(SET_LOADING_SMS_TEMPLATE, false)
      commit(SET_TEMPLATE_SMS_LIST, code === 200 ? data : [])
      return data
    } catch (e) {
      commit(SET_LOADING_SMS_TEMPLATE, false)
      commit(SET_TEMPLATE_SMS_LIST, [])
      return null
    }
  },
  async addSmsTemplate({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.addSmsTemplate(payload)
    if (res.code === 200) {
      dispatch('queryTemplateList')
    }
    return res
  },
  async deleteSmsTemplate({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.deleteSmsTemplate({id: payload})
    if (res.code === 200) {
      dispatch('queryTemplateList')
    }
    return res
  },
  async modifySmsTemplate({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.modifySmsTemplate(payload)
    if (res.code === 200) {
      dispatch('queryTemplateList')
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
